export default __webpack_public_path__ + "static/media/2482.3c42ce8e.png";